export default __webpack_public_path__ + "static/key-brain--blue-eb000e1c7276e60143f2b66c97c23dec.png";